/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BillingSubscriptionActivateRequest,
  Subscription,
  TaxInvoiceRequest,
  TaxInvoiceRequestRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 빌링키 발급 + 구독 활성화.

프론트의 `tossPayments.requestBillingAuth()`가 성공하면 successUrl에
`customerKey`/`authKey`가 querystring으로 전달됩니다. 프론트는 그 값을
`plan_id`와 함께 본 엔드포인트로 POST합니다.

1. Toss `/billing/authorizations/issue`로 billingKey 발급
2. Subscription에 billingKey + plan + next_billing_date 저장
3. (선택) 즉시 첫 결제 또는 무료 체험 후 다음 결제일에 청구
 * @summary 구독 활성화 (빌링키 발급)
 */
export const billingSubscriptionActivate = (
  billingSubscriptionActivateRequest: BodyType<BillingSubscriptionActivateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Subscription>(
    {
      url: `/api/billing/subscription/activate/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: billingSubscriptionActivateRequest,
      signal,
    },
    options,
  );
};

export const getBillingSubscriptionActivateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingSubscriptionActivate>>,
    TError,
    { data: BodyType<BillingSubscriptionActivateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingSubscriptionActivate>>,
  TError,
  { data: BodyType<BillingSubscriptionActivateRequest> },
  TContext
> => {
  const mutationKey = ["billingSubscriptionActivate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingSubscriptionActivate>>,
    { data: BodyType<BillingSubscriptionActivateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billingSubscriptionActivate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingSubscriptionActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingSubscriptionActivate>>
>;
export type BillingSubscriptionActivateMutationBody =
  BodyType<BillingSubscriptionActivateRequest>;
export type BillingSubscriptionActivateMutationError = ErrorType<unknown>;

/**
 * @summary 구독 활성화 (빌링키 발급)
 */
export const useBillingSubscriptionActivate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingSubscriptionActivate>>,
      TError,
      { data: BodyType<BillingSubscriptionActivateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingSubscriptionActivate>>,
  TError,
  { data: BodyType<BillingSubscriptionActivateRequest> },
  TContext
> => {
  const mutationOptions =
    getBillingSubscriptionActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 구독 셀프 취소.

당월 종료까지 사용 가능 (`cancel_at_period_end=True`).
Celery beat의 정기결제 task가 next_billing_date 도래 시 status=CANCELLED + 빌링키 비활성화.
 * @summary 구독 취소 (당월 종료까지 유지)
 */
export const billingSubscriptionCancel = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Subscription>(
    { url: `/api/billing/subscription/cancel/`, method: "POST", signal },
    options,
  );
};

export const getBillingSubscriptionCancelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingSubscriptionCancel>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingSubscriptionCancel>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["billingSubscriptionCancel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingSubscriptionCancel>>,
    void
  > = () => {
    return billingSubscriptionCancel(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingSubscriptionCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingSubscriptionCancel>>
>;

export type BillingSubscriptionCancelMutationError = ErrorType<unknown>;

/**
 * @summary 구독 취소 (당월 종료까지 유지)
 */
export const useBillingSubscriptionCancel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingSubscriptionCancel>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingSubscriptionCancel>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getBillingSubscriptionCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 사업자 세금계산서 발급 요청.

POST: 새 요청 생성 → 운영팀이 수동 처리 (자동화는 별 plan)
GET:  현재 사용자의 발급 요청 목록 조회
 * @summary 세금계산서 발급 요청 내역
 */
export const billingTaxInvoiceList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TaxInvoiceRequest[]>(
    { url: `/api/billing/tax-invoice-requests/`, method: "GET", signal },
    options,
  );
};

export const getBillingTaxInvoiceListQueryKey = () => {
  return [`/api/billing/tax-invoice-requests/`] as const;
};

export const getBillingTaxInvoiceListQueryOptions = <
  TData = Awaited<ReturnType<typeof billingTaxInvoiceList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof billingTaxInvoiceList>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingTaxInvoiceListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingTaxInvoiceList>>
  > = ({ signal }) => billingTaxInvoiceList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingTaxInvoiceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingTaxInvoiceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingTaxInvoiceList>>
>;
export type BillingTaxInvoiceListQueryError = ErrorType<unknown>;

export function useBillingTaxInvoiceList<
  TData = Awaited<ReturnType<typeof billingTaxInvoiceList>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTaxInvoiceList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingTaxInvoiceList>>,
          TError,
          Awaited<ReturnType<typeof billingTaxInvoiceList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingTaxInvoiceList<
  TData = Awaited<ReturnType<typeof billingTaxInvoiceList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTaxInvoiceList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingTaxInvoiceList>>,
          TError,
          Awaited<ReturnType<typeof billingTaxInvoiceList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingTaxInvoiceList<
  TData = Awaited<ReturnType<typeof billingTaxInvoiceList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTaxInvoiceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 세금계산서 발급 요청 내역
 */

export function useBillingTaxInvoiceList<
  TData = Awaited<ReturnType<typeof billingTaxInvoiceList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTaxInvoiceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingTaxInvoiceListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 사업자 세금계산서 발급 요청.

POST: 새 요청 생성 → 운영팀이 수동 처리 (자동화는 별 plan)
GET:  현재 사용자의 발급 요청 목록 조회
 * @summary 세금계산서 발급 요청
 */
export const billingTaxInvoiceCreate = (
  taxInvoiceRequestRequest: BodyType<TaxInvoiceRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TaxInvoiceRequest>(
    {
      url: `/api/billing/tax-invoice-requests/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: taxInvoiceRequestRequest,
      signal,
    },
    options,
  );
};

export const getBillingTaxInvoiceCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingTaxInvoiceCreate>>,
    TError,
    { data: BodyType<TaxInvoiceRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingTaxInvoiceCreate>>,
  TError,
  { data: BodyType<TaxInvoiceRequestRequest> },
  TContext
> => {
  const mutationKey = ["billingTaxInvoiceCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingTaxInvoiceCreate>>,
    { data: BodyType<TaxInvoiceRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billingTaxInvoiceCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingTaxInvoiceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingTaxInvoiceCreate>>
>;
export type BillingTaxInvoiceCreateMutationBody =
  BodyType<TaxInvoiceRequestRequest>;
export type BillingTaxInvoiceCreateMutationError = ErrorType<unknown>;

/**
 * @summary 세금계산서 발급 요청
 */
export const useBillingTaxInvoiceCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingTaxInvoiceCreate>>,
      TError,
      { data: BodyType<TaxInvoiceRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingTaxInvoiceCreate>>,
  TError,
  { data: BodyType<TaxInvoiceRequestRequest> },
  TContext
> => {
  const mutationOptions = getBillingTaxInvoiceCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
